/* eslint-disable max-len */
export class CommonConsultMapper {
	private readonly unicodeRegex = /[\u0080-\uFFFF]/g;

	handleUnicode = (str: string) => str.replace(this.unicodeRegex, '_');
	handleUnicodeDocuments = (documents: any[]) => documents.map(doc => (doc.nombre = this.handleUnicode(doc.nombre), doc));

}
